import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import useStyles from './PersonalisedMessage.styles';
import { calculateTextLength } from '../../../utils/common';
import clsx from 'clsx';
const PersonalisedMessage = ({ onChange, error, sendPersonalisedMessageAnalytics, personalisedMessages, occasionChosen, maxLength, pretypedMessage, }) => {
    const { classes } = useStyles();
    const editableRef = useRef(null);
    const isInputEvent = useRef(false);
    const [content, setContent] = useState('');
    const [lastKey, setLastKey] = useState('');
    const [showPersonalisedMessage, setShowPersonalisedMessage] = useState(false);
    const [initialPersonalisedMessage, setInitialPersonalisedMessage] = useState('');
    const [messageLength, setMessageLength] = useState(0);
    useEffect(() => {
        submitMessage(content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content]);
    const submitMessage = (message) => {
        const customEvent = { target: { value: formatPersonalisedMessage(message) } };
        onChange(customEvent);
    };
    const formatPersonalisedMessage = (message) => {
        return message === null || message === void 0 ? void 0 : message.trim().replace(/^To add name(,|\s)*/gi, '').replace(/From add your name$/gi, '').replace(/^To\s*,/gi, '').replace(/From(\s|,)*$/gi, '').trim();
    };
    useEffect(() => {
        var _a, _b;
        if (showPersonalisedMessage && editableRef.current) {
            setInitialPersonalisedMessage(editableRef.current.innerHTML);
            setMessageLength(calculateTextLength(((_a = editableRef.current.innerText) !== null && _a !== void 0 ? _a : '').replace(/\u00A0/g, ' ')));
            setContent(((_b = editableRef.current.innerText) !== null && _b !== void 0 ? _b : '').replace(/\u00A0/g, ' '));
            addEventsToInputs();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showPersonalisedMessage]);
    useEffect(() => {
        if (!isInputEvent.current && pretypedMessage && editableRef.current && !showPersonalisedMessage) {
            const normalisedPretypedMessage = pretypedMessage.replace(/\u00A0/g, ' ');
            editableRef.current.innerText = normalisedPretypedMessage;
            // Restore cursor position to end
            restoreCursorPosition(editableRef);
            setMessageLength(calculateTextLength(normalisedPretypedMessage));
            setContent(normalisedPretypedMessage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pretypedMessage]);
    const restoreCursorPosition = (ref) => {
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNodeContents(ref.current);
        range.collapse(false); // Cursor at end
        selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
        selection === null || selection === void 0 ? void 0 : selection.addRange(range);
    };
    const addEventsToInputs = () => {
        var _a;
        const inputElements = (_a = editableRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input');
        inputElements === null || inputElements === void 0 ? void 0 : inputElements.forEach((input) => {
            input.addEventListener('focus', handleInputFocus);
            input.addEventListener('click', handleInputClick);
        });
    };
    const handleInputFocus = (event) => {
        const input = event.target;
        const length = input.value.length;
        input.setSelectionRange(length, length);
        moveCursorOutsidetheInput(input);
    };
    const handleInputClick = (event) => {
        const input = event.target;
        const length = input.value.length;
        input.setSelectionRange(length, length);
        moveCursorOutsidetheInput(input);
    };
    const moveCursorOutsidetheInput = (input) => {
        setTimeout(() => {
            if (editableRef.current) {
                editableRef.current.focus();
                const selection = window.getSelection();
                const range = document.createRange();
                range.setStartAfter(input);
                range.collapse(true);
                selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
                selection === null || selection === void 0 ? void 0 : selection.addRange(range);
            }
        }, 0);
    };
    const populatePersonalisedMessage = () => {
        setShowPersonalisedMessage(true);
        sendPersonalisedMessageAnalytics === null || sendPersonalisedMessageAnalytics === void 0 ? void 0 : sendPersonalisedMessageAnalytics(occasionChosen);
        if (editableRef.current && editableRef.current.innerHTML !== initialPersonalisedMessage) {
            editableRef.current.innerHTML = initialPersonalisedMessage;
            setMessageLength(calculateTextLength(editableRef.current.innerText.replace(/\u00A0/g, ' ')));
            setContent(editableRef.current.innerText.replace(/\u00A0/g, ' '));
            addEventsToInputs();
        }
    };
    const handleBeforeInput = (event) => {
        const inputEvent = event;
        if (editableRef.current &&
            inputEvent.data &&
            calculateTextLength(inputEvent.data.replace(/\u00A0/g, ' ')) +
                calculateTextLength(editableRef.current.innerText.replace(/\u00A0/g, ' ')) >
                maxLength &&
            inputEvent.inputType !== 'deleteContentBackward') {
            event.preventDefault();
            setMessageLength(maxLength);
        }
    };
    const handleInput = (e) => {
        var _a, _b, _c;
        isInputEvent.current = true;
        if (editableRef.current) {
            const currentText = (_a = editableRef.current.innerText) !== null && _a !== void 0 ? _a : '';
            const newText = currentText.replace(/\u00A0/g, ' ');
            const newLength = calculateTextLength(newText);
            if (lastKey === 'Backspace' && newText === '\n') {
                editableRef.current.innerText = '';
            }
            else if (newLength > maxLength) {
                // Prevent the last input from being entered
                editableRef.current.innerText = currentText.slice(0, -1);
                // Restore cursor position to end
                restoreCursorPosition(editableRef);
            }
            setMessageLength(calculateTextLength(((_b = editableRef.current.innerText) !== null && _b !== void 0 ? _b : '').replace(/\u00A0/g, ' ')));
            setContent(((_c = editableRef.current.innerText) !== null && _c !== void 0 ? _c : '').replace(/\u00A0/g, ' '));
        }
    };
    const handlePaste = (event) => {
        var _a, _b, _c, _d;
        event.preventDefault();
        const text = ((_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/plain')) || '';
        const cleanedText = text.replace(/\u00A0/g, ' '); // Normalize non-breaking spaces
        const currentLength = calculateTextLength((_d = (_c = (_b = editableRef.current) === null || _b === void 0 ? void 0 : _b.innerText) === null || _c === void 0 ? void 0 : _c.replace(/\u00A0/g, ' ')) !== null && _d !== void 0 ? _d : '');
        const pasteLength = calculateTextLength(cleanedText);
        if (currentLength + pasteLength > maxLength) {
            event.preventDefault();
        }
        if (currentLength + pasteLength <= maxLength) {
            if (editableRef.current) {
                const selection = window.getSelection();
                if (selection === null || selection === void 0 ? void 0 : selection.rangeCount) {
                    const range = selection.getRangeAt(0);
                    range.deleteContents();
                    const textNode = document.createTextNode(cleanedText);
                    range.insertNode(textNode);
                    // Move the cursor to the end of the pasted content
                    range.setStartAfter(textNode);
                    range.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    // Manually trigger handleInput
                    handleInput(event);
                }
            }
        }
    };
    const handleKeyDown = (e) => {
        setLastKey(e.key);
    };
    const renderContentWithNewLines = (content) => {
        return content.split('\n').map((line, index) => (_jsxs(React.Fragment, { children: [line, _jsx("br", {})] }, line)));
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: classes.editableContainer, children: [_jsx("div", { ref: editableRef, className: clsx(classes.editable, { [classes.error]: error }), contentEditable: "true", role: "textbox", tabIndex: 0, "aria-labelledby": "personalised-message", "aria-multiline": "true", onInput: handleInput, onKeyDown: handleKeyDown, onBeforeInput: handleBeforeInput, onPaste: handlePaste, children: showPersonalisedMessage ? (_jsxs(_Fragment, { children: ["To ", _jsx("input", { className: classes.personalisedMessageRecipient, type: "text", value: "add name" }), _jsx("span", { children: "," }), _jsx("br", {}), _jsx("br", {}), renderContentWithNewLines(personalisedMessages[occasionChosen]), _jsx("br", {}), "From ", _jsx("input", { className: classes.personalisedMessageSender, type: "text", value: "add your name" })] })) : null }), _jsx("label", { className: classes.editableLabel, htmlFor: "editable", id: "editable-label", children: "Your Message" }), (!editableRef.current || editableRef.current.innerText === '') && (_jsx("span", { id: "editable-placeholder", className: classes.placeholder, children: "Write here..." })), _jsxs("p", { className: classes.messageBoxCharCount, children: [messageLength, " / ", maxLength] })] }), _jsx("span", { className: classes.errorMessage, children: error }), _jsx("div", { className: classes.askSuggestion, children: _jsx("button", { className: classes.suggestionMessageButton, onClick: populatePersonalisedMessage, type: "button", children: _jsx("span", { children: "Need help? Click to add our suggestion" }) }) })] }));
};
export default PersonalisedMessage;
